import React from "react";
import { Card, Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import useStyles from "./style";

const EmptyFundedProject = () => {
  const classes = useStyles();

  return (
    <div className={classes.emptyProjectContainer}>
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
      <EmptyFundedProjectItem />
    </div>
  );
};

const EmptyFundedProjectItem = () => {
  const classes = useStyles();

  return (
    <Card variant="outlined" className={classes.emptyProjectItem}>
      <Box className={classes.infoWrapper}>
        <Skeleton variant="circle" className={classes.avatar} animation={false} />
        <Box>
          <Skeleton variant="text" width={80} animation={false} />
          <Skeleton variant="text" width={60} height={12} animation={false} />
        </Box>
      </Box>
      <Skeleton
        className={classes.totalRaisedLabel}
        variant="text"
        width={60}
        height={12}
        animation={false}
      />
      <Skeleton
        className={classes.totalRaisedValue}
        variant="text"
        width={40}
        height={12}
        animation={false}
      />
      <Skeleton
        className={classes.athLabel}
        variant="text"
        width={60}
        height={12}
        animation={false}
      />
      <Skeleton
        className={classes.athValue}
        variant="text"
        width={40}
        height={12}
        animation={false}
      />
      <Skeleton variant="circle" className={classes.network} animation={false} />
    </Card>
  );
};

export default EmptyFundedProject;
